export function getQueryparam (location) {
const queryparms = new URLSearchParams(location.search);
 let tarquery =  queryparms.get('targetQuery');
return tarquery;
}
